import React from 'react'
import ColumnsAlignment from './ColumnsAlignment'
import { connect } from "react-redux";
import { handleBackgroundResume } from '../../../../services/actions/actions';

function LayoutDesign({resumeReducer,handleBackgroundResume}) {
  const {design} = resumeReducer
  return (
    <>
      <div className='bg-white p-3 rounded-md shadow-lg'>
        <div>
          <div>
            <h2 className='text-lg manpro font-bold text-gray-700'>Layout</h2>

            <ColumnsAlignment />

            <div className='mt-3 colums-colors'>
              <span className='manpro font-semibold inline-block'>Colors</span>
              <div className='grid grid-cols-6 gap-3 mt-3'>
                {design.colors.map((color,idx) => {
                  return <div onClick={() => handleBackgroundResume(color)} key={idx} className='w-10 h-10 rounded-full cursor-pointer hover:opacity-80' style={{ 'backgroundColor': color }}></div>
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

const mapStateToProps = (state) => {
  return state;
};

const mapDispatchToState = (dispatch) => {
  return {
    handleBackgroundResume: (value) => {
      dispatch(handleBackgroundResume(value))
    },
  }
}

export default connect(mapStateToProps, mapDispatchToState)(LayoutDesign)